import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import './App.scss';
import LoadingScreen from '@sharedComponent/app-action-reducer/loading';
import StatusToast from '@pages/DesignSystem/StatusToast';
import { useSelector } from 'react-redux';
import { APP_VARIABLES } from '@constants/app-constants';
import ClevertapReact from './utils/clever-tap';
import Edenredmodal from '@pages/DesignSystem/Edenredmodal';
import useSessionTimeout from './hooks/useSessionTimeout';

function App() {
  const data = useSelector((state) => state?.sharedStates);
  const currentUser = data?.currentUser;
  const subscription = data?.subscriptionProds?.[0];
  const {handleLogout, handleStayActive, remainingTime, showInactivityModal} = useSessionTimeout(currentUser);

  useEffect(() => {
    let accessToken = localStorage.getItem(APP_VARIABLES.ACCESS_TOKEN);
    const corporateId = localStorage.getItem(APP_VARIABLES.CORPORATE_ID) || '';
    const corporateName = localStorage.getItem(APP_VARIABLES.CORPORATE_NAME) || '';
    if (currentUser?.user && accessToken) {
      ClevertapReact.profile({
        Site: {
          Name: currentUser?.user?.userName,
          Email: currentUser?.user?.userEmail,
        },
      });
      ClevertapReact.event('LoginSuccess');
      ClevertapReact.onUserLogin({
        Site: {
          Name: currentUser?.user?.userName,
          Email: currentUser?.user?.userEmail,
          Identity: currentUser?.user?.userId,
          CorporateId: corporateId,
          CompanyName: corporateName,
          Role: currentUser?.user?.roles && currentUser?.user?.roles?.length > 0 ? currentUser?.user?.roles[0]?.name : '',
          subscription: subscription?.isFreeTrailOn || subscription?.isSubscriptionOn === true ? 'subscribed' : 'unsubscribed',
        },
      });
      ClevertapReact.onUserLogin({
        Site: {
          Name: currentUser?.user?.userName,
          Email: currentUser?.user?.userEmail,
          Identity: currentUser?.user?.userId,
          Role: currentUser?.user?.roles && currentUser?.user?.roles?.length > 0 ? currentUser?.user?.roles[0]?.name : '',
        },
      });
    }
  }, [currentUser?.user, subscription?.isFreeTrailOn, subscription?.isSubscriptionOn]);

  return (
    <>
      <StatusToast />
      <LoadingScreen />
      <Edenredmodal
        isOpen={showInactivityModal}
        title="You will be logged out soon"
        desc={
          <span className="session-timeout-modal-timer">
            For your security, we log you out automatically when you have not been active for 5 minutes.
            <br></br><br></br>
            <span><b>Time Left: 00:{Math.ceil(remainingTime / 1000)}</b></span>
          </span>
        }
        onOkay={handleStayActive}
        onCancel={handleLogout}
        onCancelButton="Log Out Now"
        onOkayButton="Stay Logged In"
      />
    </>
  );
}

export default withRouter(App);
